import { render } from "./full_physiotherapy_head.vue?vue&type=template&id=fcabd8f4&scoped=true"
import script from "./full_physiotherapy_head.vue?vue&type=script&lang=js"
export * from "./full_physiotherapy_head.vue?vue&type=script&lang=js"

import "./full_physiotherapy_head.vue?vue&type=style&index=0&id=fcabd8f4&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcabd8f4"]])

export default __exports__